export const hasRole = names => {
  const jsonuser = localStorage.getItem('permissions');
  if (jsonuser !== undefined && jsonuser !== null) {
    const roles = JSON.parse(jsonuser)?.value || [];
    for (const name of names) {
      if (roles.includes(name)) {
        return true;
      }
    }
  }
  return false;
};
